module.exports = __webpack_public_path__ + "assets/img/mecha-btn-7b047f78.png";